import { render } from "./ButtonSearch.vue?vue&type=template&id=dcbe4514"
import script from "./ButtonSearch.vue?vue&type=script&lang=js"
export * from "./ButtonSearch.vue?vue&type=script&lang=js"

import exportComponent from "/home/ad5coral/ad5.tech/oyadori/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__